import { i18n } from 'i18next'

import { getCurrency } from '@/i18n/getCurrency'
import { CountryCode } from '@/utils/address'

type NumberFormatType = 'number' | 'int' | 'decimal' | 'currency' | 'accounting' | 'percent'

type NumberFormatOptions = {
    i18n: i18n
    format: NumberFormatType
    currency?: string
    currencyAsCode?: boolean
    useGrouping?: boolean
    maximumFractionDigits?: number
}

export const formatNumber = (
    number: number,
    {
        format,
        currency,
        currencyAsCode,
        i18n,
        useGrouping,
        maximumFractionDigits: sourceMaximumFractionDigits,
    }: NumberFormatOptions
) => {
    let style: Intl.NumberFormatOptions['style'] = undefined
    const currencyDisplay = currencyAsCode ? 'code' : 'symbol'
    let minimumFractionDigits: number | undefined = undefined
    let maximumFractionDigits: number | undefined = undefined

    if (format === 'number') {
        style = 'decimal'
    } else if (format === 'int') {
        style = 'decimal'
        minimumFractionDigits = 0
        maximumFractionDigits = 0
    } else if (format === 'decimal') {
        minimumFractionDigits = 2
        maximumFractionDigits = 2
    } else if (format === 'currency') {
        if (!currency) {
            const [, country] = i18n.language.split('-')

            if (!country) {
                throw new Error(`No country set for formatting currency`)
            }

            currency = getCurrency(country as CountryCode).code
            if (!country) {
                throw new Error(`No currency found for country ${country} for formatting currency`)
            }
        }

        minimumFractionDigits = 2
        maximumFractionDigits = 2

        number = number / 100
    } else if (format === 'accounting') {
        style = 'decimal'

        minimumFractionDigits = 2
        maximumFractionDigits = 2

        number = number / 100
    } else {
        style = format
    }

    if (typeof sourceMaximumFractionDigits === 'number') {
        if (typeof minimumFractionDigits !== 'number' || minimumFractionDigits > sourceMaximumFractionDigits) {
            minimumFractionDigits = sourceMaximumFractionDigits
        }
        if (typeof maximumFractionDigits !== 'number' || maximumFractionDigits > sourceMaximumFractionDigits) {
            maximumFractionDigits = sourceMaximumFractionDigits
        }
    }

    // @ts-expect-error it's fine
    if (currency && style !== 'currency') {
        style = 'currency'
    }

    const result = new Intl.NumberFormat(i18n.language, {
        style,
        currency,
        currencyDisplay,
        minimumFractionDigits,
        maximumFractionDigits,
        useGrouping,
    }).format(number)

    //
    // On accounting format the minus is at the end not at the front
    //

    if (format === 'accounting' && number < 0) {
        return `${result.substring(1)}-`
    }

    return result
}
